import React, { useContext } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { WHOLESALE_FORMAT } from 'codes';
import { SALES_FILE_TYPE_IDS } from 'globals.js';

// HELPERS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import Card from '../parts/Card';
import Attachment from 'routers/interface/tools/attachment/Attachment';

// MAIN COMPONENT
const InvoiceSA3Form = () => {
  const { refetchRecord } = useContext(RecordContext);

  const { values: { sale_type_category_code, inventory, wholesale_format_id } = {} } = useFormikContext() || {};
  const { new_used } = inventory || {};

  const retailWholesale =
    wholesale_format_id === WHOLESALE_FORMAT.detailed.numeric ? 'RETAIL' : sale_type_category_code; // treat Wholesale Detail same as Retail

  const documentType = {
    0: {
      RETAIL: SALES_FILE_TYPE_IDS.EBOS_RETAIL_USED,
      WHOLESALE: SALES_FILE_TYPE_IDS.EBOS_WHOLESALE_USED
    },
    1: {
      RETAIL: SALES_FILE_TYPE_IDS.EBOS_RETAIL_NEW,
      WHOLESALE: SALES_FILE_TYPE_IDS.EBOS_WHOLESALE_NEW
    }
  };

  return (
    <Form.Body>
      <Attachment.Upload
        label="Accounting Invoice / Bill of Sale (SA3)"
        name="documentAttachment.ebos"
        documentType={documentType?.[new_used]?.[retailWholesale]}
        uploadType="sales"
        onComplete={refetchRecord}
        downloadRecent
      />
    </Form.Body>
  );
};

// EXPORT
export default function InvoiceSA3({ number, ...props }) {
  const { record: initialValues = {} } = useContext(RecordContext) || {};

  return (
    <Card
      number={number}
      title="Accounting Invoice / Bill of Sale (SA3)"
      color="yellow"
      body={
        <Form initialValues={initialValues}>
          <InvoiceSA3Form {...props} />
        </Form>
      }
    />
  );
}
